export type InventoryRollupCost = {
  costOnHand: number | null;
  costedQty: number | null;
  costedTagCount: number;
  stockedTagCount: number;
};

export function inventoryRollupCost(items: readonly InventoryRollupCost[]): InventoryRollupCost {
  let costOnHand: number | null = null;
  let costedQty: number | null = null;
  let costedTagCount = 0;
  let stockedTagCount = 0;
  for (const item of items) {
    if (item.costOnHand !== null) costOnHand = (costOnHand ?? 0) + item.costOnHand;
    if (item.costedQty !== null) costedQty = (costedQty ?? 0) + item.costedQty;
    costedTagCount += item.costedTagCount;
    stockedTagCount += item.stockedTagCount;
  }
  return { costOnHand, costedQty, costedTagCount, stockedTagCount };
}
